// extracted by mini-css-extract-plugin
export default {"main":"_6462d572f6 _61e085a97b","xmark":"b2afc429dc","fl_img":"_256461f2b2 _3a90c43602"};